import server from '../utils/server';

export function profileState(
  state = {
    profilesByIds: {},
    welcomesInDelay: null,
  },
  action
) {
  switch (action.type) {
    case 'RECEIVED_PROFILES': {
      const profilesByIds = { ...state.profilesByIds, ...action.value };
      return { ...state, profilesByIds };
    }
    case 'RECEIVED_WELCOMES_IN_DELAY': {
      return { ...state, ...action.value };
    }
    default: {
      return state;
    }
  }
}

export const getProfiles = ({
  employeeIds,
  attributes,
  nilAttrs = {},
}) => async dispatch => {
  const body = {
    employee_ids: employeeIds,
    nil_attributes: nilAttrs,
    attributes,
  };
  const profiles = await server.post('/api/v2/profiles/by_employee_id', body);
  const defaultProfiles = {};
  employeeIds.forEach(employeeId => {
    defaultProfiles[employeeId] = {};
  });
  dispatch({
    type: 'RECEIVED_PROFILES',
    value: {
      ...defaultProfiles,
      ...profiles,
    },
  });
};

export const getWelcomesInDelay = () => async dispatch => {
  const data = await server.get('/api/v2/profiles/welcomes_in_delay');

  dispatch({
    type: 'RECEIVED_WELCOMES_IN_DELAY',
    value: {
      welcomesInDelay: {
        count: data.welcomes_in_delay,
        isSending: data.sending_delayed_welcomes,
      },
    },
  });
};

export const sendAllDelayedWelcomes = () => async dispatch => {
  await server.post('/api/v2/profiles/send_delayed_welcomes');
  dispatch({
    type: 'SENDING_ALL_DELAYED_WELCOME_EMAILS',
  });
};
